import { createRouter, createWebHistory } from "vue-router";
import {
  clearWebviewToken,
  getWebviewToken,
  readIncomingWebviewToken,
  storeWebviewToken,
} from "../utils/webviewAuth.js";

const routes = [
  {
    path: "/",
    name: "stationElementsHome",
    component: () => import("../views/StationElementsHome.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/no-permission",
    name: "noPermission",
    component: () => import("../views/NoPermission.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: {
      name: "noPermission",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = "智瞰绿能";

  if (to.name === "stationElementsHome") {
    const incomingToken = readIncomingWebviewToken(to.query);
    if (incomingToken) storeWebviewToken(incomingToken);

    if (getWebviewToken()) {
      next();
    } else {
      next({ name: "noPermission", replace: true });
    }
    return;
  }

  if (from.name === "stationElementsHome") {
    clearWebviewToken();
  }

  if (to.name === "noPermission") {
    next();
    return;
  }

  next({ name: "noPermission", replace: true });
});

export default router;
